import { combineEpics } from 'redux-observable';
import { coreEpics } from '@/core';
import { loaderEpic } from '@/core/features/loader';
import { demoEpic } from '@/slices/demo';
import { authEpic } from '@/slices/auth';
import { referenceDataEpic } from '@/slices/referenceData';
import { propertySearchEpic } from '@/slices/propertySearch';
import { favoritesEpic } from '@/slices/favorites';
import { myRequestsEpic } from '@/slices/myRequests';
import { notificationsEpic } from '@/slices/notifications';
import { adminItemsEpic } from '@/slices/adminItems';

export default combineEpics(
  coreEpics,
  demoEpic,
  loaderEpic,
  authEpic,
  referenceDataEpic,
  propertySearchEpic,
  favoritesEpic,
  myRequestsEpic,
  notificationsEpic,
  adminItemsEpic,
);
